import styled from 'styled-components';
import { FormGroup } from '@material-ui/core';

export const Groups = styled(FormGroup)`
  fieldset {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(220, 224, 229, 0.75);

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  .MuiInputLabel-formControl {
    position: static;
    transform: none;
  }
`;
